/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { TimePicker } from "@progress/kendo-react-dateinputs";
import {
  useGetCashCenters,
  useGetOffices,
  useGetRegions,
  useAddNewRoute,
} from "services/routes-api";
import {
  Button,
  Combobox,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@repo/ui";
import { Card, CardBody, Flex, Heading } from "@chakra-ui/react";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import Loader from "../../components/PageLoader";
import { formatDate } from "date-fns";

const jobPriorities = [
  { value: "1", label: "High" },
  { value: "2", label: "Normal" },
  { value: "3", label: "Low" },
];

const routeType = [
  { label: "Morning Route", value: "Morning Route" },
  { label: "Dedicated Route", value: "Dedicated Route" },
  { label: "Night TVM Route", value: "Night TVM Route" },
  { label: "VIT Team", value: "VIT Team" },
  { label: "Foot Team", value: "Foot Team" },
  { label: "Bike Rider", value: "Bike Rider" },
  { label: "FLM Route", value: "FLM Route" },
  { label: "Mobile ATM Team", value: "FLM Route Team" },
  { label: "Internal Route", value: "FLM Route Route" },
];

const currentDate = new Date();

function AddRoute() {
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [btnSaveText, setBtnSaveText] = useState("Add Route");

  const [route, setRoute] = useState({
    cashCenter: "",
    office: "",
    routeNo: "",
    routeType: "",
    region: "",
    description: "",
    routeArea: "",
    priority: "2",
    requiredTeamMembers: 0,
    teamNationalityCount: 0,
    routeStartTime: currentDate,
    routeEndTime: currentDate,
  });

  const [error, setError] = useState({
    cashCenter: "",
    office: "",
    routeNo: "",
    description: "",
    routeArea: "",
    region: "",
    priority: "",
    requiredTeamMembers: 0,
    teamNationalityCount: 0,
    busTime: null,
    dispatchTime: null,
  });

  const { data: cashCenters } = useGetCashCenters();
  const { data: cities } = useGetRegions("UAE");
  const { mutate: getOffices, data: offices } = useGetOffices();
  const {
    mutate: addNewRoute,
    isPending: addingRoute,
    isSuccess: addNewRouteSuccess,
    isError: addNewRouteError,
  } = useAddNewRoute();

  const onCashCentersChanged = (value) => {
    setRoute({ ...route, cashCenter: value });
    if (!value) return;
    getOffices(value);
  };

  const onBtnAddRouteClicked = () => {
    let errorCount = 0;

    const errorObj = {
      cashCenter: "",
      routeNo: "",
      description: "",
      region: "",
      routeType: "",
      routeArea: "",
      priority: "",
      requiredTeamMembers: 0,
      teamNationalityCount: 0,
      busTime: null,
      dispatchTime: null,
    };

    if (!route.cashCenter) {
      errorCount++;
      errorObj.cashCenter = "red-500";
    }
    if (!route.description) {
      errorCount++;
      errorObj.description = "red-500";
    }
    if (!route.routeNo) {
      errorCount++;
      errorObj.routeNo = "red-500";
    }
    if (!route.routeArea) {
      errorCount++;
      errorObj.routeArea = "red-500";
    }
    if (route.requiredTeamMembers === 0 || route.requiredTeamMembers > 5) {
      errorCount++;
      errorObj.requiredTeamMembers = "red-500";
    }
    if (route.teamNationalityCount === 0 || route.requiredTeamMembers > 5) {
      errorCount++;
      errorObj.teamNationalityCount = "red-500";
    }
    if (!route.routeStartTime) {
      errorCount++;
      errorObj.routeStartTime = "red-500";
    }
    if (!route.routeEndTime) {
      errorCount++;
      errorObj.routeEndTime = "red-500";
    }
    if (!route.routeType) {
      errorCount++;
      errorObj.routeType = "red-500";
    }

    if (!route.region) {
      errorCount++;
      errorObj.region = "red-500";
    }

    if (errorCount) {
      setError(errorObj);
      return;
    }
    setError(errorObj);

    const obj = {
      cashCenterId: route.cashCenter,
      officeId: route.office,
      routeType: route.routeType,
      routeNo: route.routeNo,
      routeArea: route.routeArea,
      description: route.description,
      region: route.region,
      priority: route.priority,
      requiredTeamMembers: route.requiredTeamMembers,
      teamNationalityCount: route.teamNationalityCount,
      routeStartTime: formatDate(
        route.routeStartTime,
        "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
      ),
      routeEndTime: formatDate(
        route.routeEndTime,
        "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
      ),
    };

    setBtnDisabled(true);
    setBtnSaveText("Adding Route....");
    addNewRoute(obj);
  };

  useEffect(() => {
    if (addNewRouteSuccess) {
      setBtnDisabled(false);
      setBtnSaveText("Add Route");
      setRoute({
        cashCenter: "",
        office: "",
        routeType: "",
        routeNo: "",
        region: "",
        description: "",
        routeArea: "",
        priority: "",
        requiredTeamMembers: 0,
        teamNationalityCount: 0,
        routeStartTime: currentDate,
        routeEndTime: currentDate,
      });
    }
    if (addNewRouteError) {
      setBtnDisabled(false);
      setBtnSaveText("Add Route");
    }
  }, [addNewRouteSuccess, addNewRouteError]);

  return (
    <>
      {addingRoute ? <Loader /> : null}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Routes", link: Paths.routesList },
            { text: "Add Route", isCurrentPage: true },
          ]}
        />
        <Flex w="100%">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <Heading size="md" mb={4}>
                Add New Route
              </Heading>

              {/* === Form Starts Here === */}
              <div className="flex gap-4 mb-3">
                <div className="flex-1">
                  <label
                    className={`text-sm font-[500] text-${error.cashCenter}`}
                  >
                    Cash Center<sup className="text-red-500">*</sup>
                  </label>
                  <Combobox
                    data={cashCenters?.data?.map((m) => ({
                      value: m.cashCenterId,
                      label: m.name,
                    }))}
                    value={route.cashCenter}
                    setValue={onCashCentersChanged}
                    placeholder="Select Cash center"
                  />
                </div>

                <div className="flex-1">
                  <label className="text-sm font-[500]">Office</label>
                  <Combobox
                    data={offices?.data?.map((m) => ({
                      value: m.officeId,
                      label: m.officeName,
                    }))}
                    placeholder="Select Office"
                    value={route.office}
                    setValue={(e) => {
                      setRoute({ ...route, office: e });
                    }}
                  />
                </div>

                <div className="flex-1">
                  <label
                    className={`text-sm font-[500] text-${error.routeType}`}
                  >
                    Route Type <sup className="text-red-500">*</sup>
                  </label>
                  <Combobox
                    data={routeType}
                    placeholder="Select Route Type"
                    value={route.routeType}
                    setValue={(e) => {
                      setRoute({ ...route, routeType: e });
                    }}
                  />
                </div>
              </div>

              <div className="flex gap-4 mb-3">
                <div className="flex-1">
                  <label className={`text-sm font-[500] text-${error.routeNo}`}>
                    Route No<sup className="text-red-500">*</sup>
                  </label>
                  <Input
                    placeholder="Route No"
                    value={route.routeNo}
                    onChange={(e) =>
                      setRoute({ ...route, routeNo: e.target.value })
                    }
                  />
                </div>

                <div className="flex-1">
                  <label
                    className={`text-sm font-[500] text-${error.description}`}
                  >
                    Description<sup className="text-red-500">*</sup>
                  </label>
                  <Input
                    placeholder="Route Description"
                    value={route.description}
                    onChange={(e) =>
                      setRoute({ ...route, description: e.target.value })
                    }
                  />
                </div>

                <div className="flex-1">
                  <label className={`text-sm font-[500] text-${error.region}`}>
                    Region<sup className="text-red-500">*</sup>
                  </label>
                  <Combobox
                    data={cities?.data?.map((m) => ({
                      label: m.name,
                      value: m.name,
                    }))}
                    value={route.region}
                    setValue={(e) => setRoute({ ...route, region: e })}
                    placeholder="Select Region"
                  />
                </div>
              </div>

              <div className="flex gap-4 mb-3">
                <div className="flex-1">
                  <label
                    className={`text-sm font-[500] text-${error.routeArea}`}
                  >
                    Area<sup className="text-red-500">*</sup>
                  </label>
                  <Input
                    placeholder="Route Area"
                    value={route.routeArea}
                    onChange={(e) =>
                      setRoute({ ...route, routeArea: e.target.value })
                    }
                  />
                </div>

                <div className="flex-1">
                  <label
                    className={`text-sm font-[500] text-${error.priority}`}
                  >
                    Priority<sup className="text-red-500">*</sup>
                  </label>
                  <Select
                    onValueChange={(e) => setRoute({ ...route, priority: e })}
                    value={route.priority}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Route Priority" />
                    </SelectTrigger>
                    <SelectContent>
                      {jobPriorities.map((item) => (
                        <SelectItem key={item.value} value={item.value}>
                          {item.label}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>

                <div className="flex-1">
                  <label
                    className={`text-sm font-[500] text-${error.requiredTeamMembers}`}
                  >
                    Required Team Members
                    <sup className="text-red-500">*</sup>
                  </label>
                  <NumericTextBox
                    min={1}
                    max={5}
                    className="h-10"
                    placeholder="Required Team Members Count"
                    value={route.requiredTeamMembers}
                    onChange={(e) =>
                      setRoute({
                        ...route,
                        requiredTeamMembers: e.target.value,
                      })
                    }
                  />
                  {error.requiredTeamMembers ? (
                    <i className="text-sm text-red-500">
                      Min 1 or Max 5 team members allowed.
                    </i>
                  ) : null}
                </div>
              </div>
              <div className="flex gap-4 mb-3">
                <div className="flex-1">
                  <label
                    className={`text-sm font-[500] text-${error.teamNationalityCount}`}
                  >
                    Co-National Count
                    <sup className="text-red-500">*</sup>
                  </label>
                  <NumericTextBox
                    min={1}
                    max={5}
                    className="h-10"
                    placeholder="Max. Same Nationals Count"
                    value={route.teamNationalityCount}
                    onChange={(e) =>
                      setRoute({
                        ...route,
                        teamNationalityCount: e.target.value,
                      })
                    }
                  />

                  {error.teamNationalityCount ? (
                    <i className="text-sm text-red-500">
                      Min 1 or Max 5 nationality allowed.
                    </i>
                  ) : null}
                </div>

                <div className="flex-1">
                  <label
                    className={`text-sm font-[500] text-${error.routeStartTime}`}
                  >
                    Route Start Time<sup className="text-red-500">*</sup>
                  </label>
                  <TimePicker
                    placeholder="Route Start Time"
                    className="h-10"
                    value={route.routeStartTime}
                    onChange={(e) =>
                      setRoute({ ...route, routeStartTime: e.value })
                    }
                  />
                </div>

                <div className="flex-1">
                  <label
                    className={`text-sm font-[500] text-${error.routeEndTime}`}
                  >
                    Route End Time<sup className="text-red-500">*</sup>
                  </label>
                  <TimePicker
                    className="h-10"
                    placeholder="Route End Time"
                    value={route.routeEndTime}
                    onChange={(e) =>
                      setRoute({ ...route, routeEndTime: e.value })
                    }
                  />
                </div>
              </div>

              <div className="border-b my-3 bg-accent" />
              <Button
                variant="secondary"
                onClick={onBtnAddRouteClicked}
                disabled={btnDisabled}
                className="ml-auto flex w-[140px]"
              >
                {btnSaveText}
              </Button>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}

export default AddRoute;
